module.exports = __webpack_public_path__ + "img/Ladli foundation.0ed1ce2b.png";